import { useLayoutEffect } from "react";
import { atom, useAtomValue, useSetAtom } from "jotai";
import type { ActiveApp } from "./useActiveApp";

// On mobile [code]smith routes the app-switcher rail is hidden so the chat gets
// the full width; it shows beside the session list overlay, whose toggle is
// then the way back to app navigation. Screens there with no such toggle
// mount <KeepAppRailOnMobile /> so they keep the rail.
const sessionSidebarOpenAtom = atom(false);
const keepRailCountAtom = atom(0);

/**
 * Whether the rail should carry `max-md:hidden`. CSS rather than a viewport
 * hook, which reads false during hydration and would flash the rail.
 */
export function useAppRailHiddenOnMobile(activeApp: ActiveApp): boolean {
  const sessionSidebarOpen = useAtomValue(sessionSidebarOpenAtom);
  const keepRailCount = useAtomValue(keepRailCountAtom);
  return (
    activeApp === "codesmith" && !sessionSidebarOpen && keepRailCount === 0
  );
}

/** Layout effect so the rail lands in the same paint as the overlay. */
export function usePublishMobileSessionSidebarOpen(open: boolean) {
  const setOpen = useSetAtom(sessionSidebarOpenAtom);
  useLayoutEffect(() => {
    setOpen(open);
    return () => setOpen(false);
  }, [open, setOpen]);
}

export function KeepAppRailOnMobile() {
  const setCount = useSetAtom(keepRailCountAtom);
  useLayoutEffect(() => {
    setCount((count) => count + 1);
    return () => setCount((count) => count - 1);
  }, [setCount]);
  return null;
}
